export default "__VITE_ASSET__4R6sx6rF__"